import { mockData } from "./Mock";
import { RemoteJob } from "../../models/RemoteJob";
import { JobApplicant } from "../../models/JobApplicant";
import { EducationLevel, Gender } from "../../models/Resume";

const mockJobs: RemoteJob[] = [
    {
        id: "job_001",
        title: "高级Java开发工程师",
        description: "负责公司核心产品的后端开发工作，参与系统架构设计和技术选型。",
        status: "active",
        type: 1,
        salaryRangeStart: 20,
        salaryRangeEnd: 30,
        isHidden: false,
        isClosed: false,
        createdAt: "2024-01-01T00:00:00Z",
        updatedAt: "2024-01-01T00:00:00Z",
    },
    {
        id: "job_002",
        title: "前端开发工程师",
        description: "负责公司产品的前端界面开发和用户体验优化。",
        status: "active",
        type: 1,
        salaryRangeStart: 15,
        salaryRangeEnd: 25,
        isHidden: false,
        isClosed: false,
        createdAt: "2024-01-02T00:00:00Z",
        updatedAt: "2024-01-02T00:00:00Z",
    },
    {
        id: "job_003",
        title: "产品经理",
        description: "负责产品规划、需求分析和产品设计，推动产品从概念到落地的全过程。",
        status: "closed",
        type: 2,
        salaryRangeStart: 25,
        salaryRangeEnd: 35,
        isHidden: false,
        isClosed: true,
        createdAt: "2024-01-03T00:00:00Z",
        updatedAt: "2024-01-04T00:00:00Z",
    },
];

mockData.set("getJobs", mockJobs);

const mockJobApplicants: JobApplicant[] = [
    {
        applicationId: "app_001",
        jobId: "job_001",
        userId: "seller_001",
        cvId: "RES001",
        name: "张三",
        gender: Gender.MALE,
        education: EducationLevel.MASTER,
        firstWorkDate: "2012-07",
        phone: "13800138001",
        expectedSalaryStart: 15,
        expectedSalaryEnd: 25,
        status: "pending",
        appliedAt: "2024-01-10T10:00:00Z",
    },
    {
        applicationId: "app_002",
        jobId: "job_001",
        userId: "seller_002",
        cvId: "RES002",
        name: "李四",
        gender: Gender.FEMALE,
        education: EducationLevel.FIRST_BACHELOR,
        firstWorkDate: "2015-07",
        phone: "13800138002",
        expectedSalaryStart: 12,
        expectedSalaryEnd: 18,
        status: "reviewing",
        appliedAt: "2024-01-11T14:30:00Z",
    },
];

mockData.set("getJobApplicants", mockJobApplicants);

export { mockJobs };
